import { VrElementField } from '../../../shared/vr-element-field/vr-element-field';

export abstract class VrCheckbox extends VrElementField { }
